<!--
 * @Description:
 * @Author: ma.cq
 * @Date: 2020-04-01 10:15:23
 * @LastEditors: ma.cq
 * @LastEditTime: 2020-04-09 14:31:23
 -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    @close="handleClose">
    <el-form :model="form" ref="form" :rules="rules" label-width="80px">
      <el-form-item label="银行名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入银行名称"></el-input>
      </el-form-item>
      <el-form-item label="银行网址" prop="link">
        <el-input v-model="form.link" placeholder="请输入银行网址"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import { checkUrl } from '../../../common/verify'

export default {
  name: 'addOrEditDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: false,
      id: '',
      form: {
        name: '',
        link: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入银行名称' }
        ],
        link: [
          { required: true, message: '请输入银行链接' },
          { pattern: checkUrl, message: '请输入带http或https的完整链接' }
        ]
      }
    }
  },
  computed: {
    title () {
      return this.isEdit ? '编辑' : '新增'
    },
    isEdit () {
      return !this.$lodash.isEmpty(this.info)
    }
  },
  methods: {
    ...mapActions(['getUploadCenterCooperateBankList', 'addOrEditUploadCenterCooperateBank']),
    handleClose () {
      this.$emit('update:show', false)
    },
    handleSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {
            title: this.form.name,
            url: this.form.link
          }
          if (this.isEdit) {
            params = {
              ...params,
              id: this.id
            }
          }
          this.addOrEditUploadCenterCooperateBank(params).then(() => {
            this.$message.success('保存成功')
            this.handleClose()
            this.getUploadCenterCooperateBankList()
          })
        } else {
          return false
        }
      })
    },
    formatForm (form) {
      const {
        id,
        title,
        url
      } = form
      this.id = id
      return {
        name: title,
        link: url
      }
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = this.isEdit ? this.formatForm(this.info) : {
          name: '',
          link: ''
        }
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-input, /deep/ .el-select {
  width: 200px;
}
</style>
